import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Breadcrumbs } from '@mui/material/';

import { useAuth } from '../hook/useAuth';
import { Box, Typography, } from '@mui/material/';
import dayjs from 'dayjs';

const MenuTop = () => {

    const { signout } = useAuth()
    const navigate = useNavigate()

    return (
        <div>
            <header>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 3, }}>

                    <Breadcrumbs id="navbar">
                        <NavLink to='/' className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : "" } >
                            <Typography variant='button' >
                                Статистика
                            </Typography>
                        </NavLink>

                        <NavLink to='/orders' className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : "" } >
                            <Typography variant='button' >
                                Заказы
                            </Typography>
                        </NavLink>

                        <NavLink to='/shipments' className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : "" } >
                            <Typography  variant='button' >
                                Отправки
                            </Typography>
                        </NavLink>

                        <NavLink to='/monitor' className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : "" } >
                            <Typography variant='button' >
                                Мониторинг
                            </Typography>
                        </NavLink>

                        <NavLink to='/logs' className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : "" } >
                            <Typography variant='button' >
                                Журнал
                            </Typography>
                        </NavLink>
                    </Breadcrumbs>

                    <Breadcrumbs>

                        <Typography variant='button' style={{cursor:'pointer'}} color={'#1976d2'} onClick={() => signout(() => navigate('/connexion', { replace: true }))}>
                            Выйти
                        </Typography>


                    </Breadcrumbs>


                </Box>



            </header>

            <main className="container">
                <Outlet />
            </main>



            <footer className="container" style={{marginTop:'40px', marginBottom: '20px'}}>
                <Typography variant='subtitle' sx={{fontSize:'small', color:'#7f7f7f'}}>&copy; {dayjs().format('YYYY')} CMS</Typography>
            </footer>
        </div>
    )
}

export { MenuTop }